import { render, staticRenderFns } from "./ModalOnceReply.vue?vue&type=template&id=b2e037ca&scoped=true&"
import script from "./ModalOnceReply.vue?vue&type=script&lang=js&"
export * from "./ModalOnceReply.vue?vue&type=script&lang=js&"
import style0 from "./ModalOnceReply.vue?vue&type=style&index=0&id=b2e037ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e037ca",
  null
  
)

export default component.exports